import type { ComputedRef } from 'vue';

enum PwaInstructionsPlatform {
  ANDROID = 'android',
  IOS = 'ios',
  OTHER = 'other',
}

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>;
};

type PwaService = {
  readonly isInstallActionVisible: ComputedRef<boolean>;
  readonly instructionsPlatform: ComputedRef<PwaInstructionsPlatform>;
  init: () => void;
  requestInstallation: () => Promise<boolean>;
};

export { PwaInstructionsPlatform, type BeforeInstallPromptEvent, type PwaService };
